import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Spinner } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ShortRedirectPage() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const resolve = async () => {
      try {
        const response = await axios.get(`${API}/api/r/${code}`);
        navigate(`/locate/${response.data.geoloc_token}`, { replace: true });
      } catch {
        navigate('/', { replace: true });
      }
    };
    resolve();
  }, [code, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <Spinner size={32} className="animate-spin text-green-600" />
    </div>
  );
}
